import React from "react";
import { motion } from "framer-motion";

export default function ScrollReveal({
  children,
  delay = 0,
  y = 40,
  duration = 0.6,
  as = "div",
  className = "",
  ...rest
}) {
  const MotionComponent = motion[as] || motion.div;
  return (
    <MotionComponent
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionComponent>
  );
}
